import { AddButton } from "./add-button";
import { Chip } from "./chip";
import { EditForm } from "./edit-form";
import { List } from "./list";
import { Row } from "./row";
import { Trigger } from "./trigger";

/**
 * `StepSequences` — compound component for editing the per-step sequence
 * list on a care plan (template) appointment step.
 *
 * Usage:
 *   <StepSequencesProvider stepId={step.id}>
 *     <StepSequences.Chip />        // card surface
 *   </StepSequencesProvider>
 *
 * The detail-panel surface composes `Trigger`, `List`, and `EditForm`
 * directly with parent-owned navigation — see `appointment-step-detail.tsx`.
 */

export {
  StepSequencesProvider,
  SequencesContext,
  useSequences,
} from "./context";

export { Chip } from "./chip";
export { List } from "./list";
export { Row } from "./row";
export { AddButton } from "./add-button";
export { EditForm } from "./edit-form";
export { Trigger } from "./trigger";

export const StepSequences = {
  Chip,
  List,
  Row,
  AddButton,
  EditForm,
  Trigger,
};

export type {
  SequenceDraft,
  SequencesState,
  SequencesActions,
  SequencesMeta,
  SequencesContextValue,
  EffectType,
} from "./types";
